import { useEffect, useState } from "react";
import { Search } from "lucide-react";
import { getAuthors } from "@/lib/api";
import AuthorCard from "@/components/AuthorCard";
import Seo from "@/components/Seo";

export default function Autores() {
  const [authors, setAuthors] = useState([]);
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const t = setTimeout(() => {
      getAuthors(q ? { q } : {})
        .then(setAuthors)
        .finally(() => setLoading(false));
    }, 250);
    return () => clearTimeout(t);
  }, [q]);

  return (
    <>
      <Seo title="Autores" description="Conoce a los autores de Editorial Harvest." />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 pt-14 pb-8">
        <p className="hv-overline">Directorio</p>
        <h1 className="font-serif text-4xl md:text-5xl text-[#0f2544] mt-3">Nuestros autores</h1>
        <p className="text-[#4a4a45] mt-4 max-w-2xl font-medium">
          Cada libro comienza con una voz. Conoce a las personas que forman parte de Editorial Harvest.
        </p>
        <div className="relative max-w-md mt-8">
          <Search size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-[#a09b90]" />
          <input
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Buscar autor por nombre..."
            className="w-full rounded-full border border-[#0f2544]/15 bg-white pl-11 pr-4 py-2.5 text-sm outline-none focus:border-[#1f44e0] transition-colors"
            data-testid="authors-search"
          />
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-12 md:py-16" data-testid="authors-grid">
        {loading ? (
          <p className="text-[#8a8a83]">Cargando...</p>
        ) : authors.length === 0 ? (
          <p className="text-[#8a8a83]">No se han encontrado autores.</p>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-8 md:gap-10">
            {authors.map((a) => (
              <AuthorCard key={a.slug} author={a} />
            ))}
          </div>
        )}
      </section>
    </>
  );
}
